var _path, _g, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3289_48422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 0.667969H14.9947V14.9972H0.666016V0.667969Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3289_48422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07164 13.118C4.45831 13.118 4.82297 13.2646 5.20897 13.42C7.57364 14.5133 10.3703 14.016 12.1923 12.1946C14.5963 9.7893 14.5963 5.87664 12.1923 3.47264C11.0283 2.30864 9.48031 1.66797 7.83231 1.66797C6.18364 1.66797 4.63497 2.3093 3.47164 3.4733C1.64897 5.29464 1.15297 8.0913 2.23631 10.4333C2.39231 10.8193 2.54297 11.1953 2.54297 11.586C2.54297 11.976 2.40897 12.3686 2.29097 12.7153C2.19364 13.0006 2.04631 13.4313 2.14097 13.526C2.23364 13.622 2.66697 13.4706 2.95297 13.3726C3.29631 13.2553 3.68564 13.1206 4.07164 13.118ZM7.81564 14.9973C6.79697 14.9973 5.77164 14.782 4.81231 14.338C4.52964 14.2246 4.26497 14.118 4.07497 14.118C3.85631 14.1193 3.56231 14.2206 3.27831 14.3186C2.69564 14.5186 1.97031 14.768 1.43364 14.2333C0.898974 13.698 1.14564 12.9746 1.34431 12.3926C1.44231 12.106 1.54297 11.81 1.54297 11.586C1.54297 11.402 1.45431 11.1673 1.31831 10.8293C0.0696404 8.13264 0.646974 4.88264 2.76497 2.76597C4.11697 1.4133 5.91631 0.667969 7.83164 0.667969C9.74697 0.667969 11.547 1.41264 12.899 2.7653C15.6936 5.55997 15.6936 10.1066 12.899 12.9013C11.529 14.272 9.68431 14.9973 7.81564 14.9973Z",
    fill: "#ED9645"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4643 8.77474C10.0963 8.77474 9.79492 8.47674 9.79492 8.10807C9.79492 7.73941 10.0903 7.44141 10.4583 7.44141H10.4643C10.8323 7.44141 11.1309 7.73941 11.1309 8.10807C11.1309 8.47674 10.8323 8.77474 10.4643 8.77474Z",
    fill: "#ED9645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79043 8.77474C7.42243 8.77474 7.12109 8.47674 7.12109 8.10807C7.12109 7.73941 7.41576 7.44141 7.78443 7.44141H7.79043C8.15843 7.44141 8.45709 7.73941 8.45709 8.10807C8.45709 8.47674 8.15843 8.77474 7.79043 8.77474Z",
    fill: "#ED9645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11855 8.77474C4.75055 8.77474 4.44922 8.47674 4.44922 8.10807C4.44922 7.73941 4.74455 7.44141 5.11255 7.44141H5.11855C5.48655 7.44141 5.78522 7.73941 5.78522 8.10807C5.78522 8.47674 5.48655 8.77474 5.11855 8.77474Z",
    fill: "#ED9645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.5f969d445063a4fd90f69ef8582e6661.svg";
export { ForwardRef as ReactComponent };